import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../base-component/base.component';
import { InvoiceStatus } from '@features/invoices/enums/invoice-status.enum';
import { MediaApiService } from '@shared-features/services/media-api.service';

@Component({
  selector: 'app-uploaded-file',
  templateUrl: './uploaded-file.component.html',
  styleUrls: ['./uploaded-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadedFileComponent extends BaseComponent {
  @Input() title: string;
  @Input() mediaId: number;
  @Input() invoiceStatus: InvoiceStatus;
  @Output() downloadClicked = new EventEmitter();
  @Output() removedAttachmentClicked = new EventEmitter();
  @Input() hasRemoveButton: boolean = false;

  constructor(private mediaApiService: MediaApiService) {
    super();
  }

  onDownloadClicked(): void {
    if (this.mediaId) {
      this.load(this.mediaApiService.getMedia(this.mediaId), {
        isLoadingTransparent: true,
      }).subscribe((media) => {
        window.open(media.url, '_blank');
      });
    } else {
      this.downloadClicked.emit({});
    }
  }

  onRemovedAttachmentClicked() {
    this.removedAttachmentClicked.emit(true);
  }
}
